import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { CoreApiConfiguration } from '../coreApiConfiguration';
import { Allergy } from '../../../models/core/allergy';
import { ServiceBase } from '../../../infrastructure/serviceBase.component';
@Injectable()
export class AllergyService extends ServiceBase {

    private actionUrl: string;
    private headers: Headers;
    private _url: string;

    constructor(private _http: HttpClient, private _configuration: CoreApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this._url = this.actionUrl + _configuration.allergy.url;
    }

    getIncludeAllergyType = (): Observable<Allergy[]> => {
        return this._http.get<any>(this._url);
    }

    getByAllergyType = (allergyTypeId: number): Observable<Allergy[]> => {
        return this._http.get<any>(this._url + '?allergyTypeId=' + allergyTypeId);
    }

    insert = (data: Allergy): Observable<Allergy> => {
        return this._http.post<any>(this._url, data);
    }

    update = (data: Allergy): Observable<Allergy> => {
        return this._http.put<any>(this._url, data);
    }
}
